// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width: 1264px) {\n.container[data-v-77ef69c4] {\n    max-width: 1185px;\n}\n.container.container--fluid[data-v-77ef69c4] {\n    max-width: 100%;\n}\n}", ""]);
// Exports
module.exports = exports;
